import React, { useState } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { useInView } from 'react-intersection-observer'

import CardChat from '../../molecules/card-chat/card-chat'

import iconUser_1 from '../../../assets/images/prebioticos-section/icono_usuaria.png'
import iconUser_2 from '../../../assets/images/prebioticos-section/icono_usuaria2.png'
import iconUser_3 from '../../../assets/images/prebioticos-section/icono_usuaria3.png'
import iconNosotras from '../../../assets/images/prebioticos-section/icono_nosotras.png'
import iconChat from '../../../assets/images/prebioticos-section/icon_chat.png'
import iconOk from '../../../assets/images/prebioticos-section/icon_ok.png'
import iconEquis from '../../../assets/images/prebioticos-section/icon_equis.png'
import icon1 from '../../../assets/images/prebioticos-section/icon_1.png'
import icon2 from '../../../assets/images/prebioticos-section/icon_2.png'
import icon3 from '../../../assets/images/prebioticos-section/icon_3.png'
import icon1b from '../../../assets/images/prebioticos-section/icon_1b.png'
import icon2b from '../../../assets/images/prebioticos-section/icon_2b.png'
import icon3b from '../../../assets/images/prebioticos-section/icon_3b.png'

import './prebioticos-section.scss'

const PrebioticosSection = ({ isMobile }) => {
  const [ref, inView] = useInView({ threshold: 0.8, triggerOnce: true })
  const [ref2, inView2] = useInView({ threshold: 1, triggerOnce: true })
  const [ref3, inView3] = useInView({ threshold: 1, triggerOnce: true })
  const [ref4, inView4] = useInView({ threshold: 1, triggerOnce: true })
  const [ref5, inView5] = useInView({ threshold: 1, triggerOnce: true })

  const cardsInfo = [
    {
      name: 'Sofía',
      ubication: 'Medellín, Protectores diarios',
      comment:
        '“Yo he visto que se maneja en los yogures, en los lácteos como para prevenir cosas…”',
    },
    {
      name: 'Andrea',
      ubication: 'Bogotá, Pañitos húmedos',
      comment:
        '“Lo relaciono con defensas, protección, algo beneficioso para el cuerpo… ”',
    },
    {
      name: 'Laura',
      ubication: 'Barranquilla, Pañitos húmedos',
      comment:
        '“Yo me imagino que es un ingrediente que te entrega vitaminas, que es más saludable al cuerpo”',
    },
  ]

  const infoProbioticos = [
    {
      firstItem: true,
      icon: iconEquis,
      description: [
        <>
          <span>
            PROBIÓTICOS, <br />
          </span>
          bacterias que efectivamente encontrarás en los yogures.
        </>,
      ],
    },
    {
      icon: icon1b,
      description: [
        <>
          <b>Son bacterias beneficiosas que viven </b>
          en diferentes partes de tu cuerpo.
        </>,
      ],
    },
    {
      icon: icon2b,
      description: [
        <>
          <b>Mejoran la salud </b>
          general de tu organismo.
        </>,
      ],
    },
    {
      icon: icon3b,
      description: [<>Los encuentras en las vitaminas.</>],
    },
  ]

  const infoPrebioticos = [
    {
      firstItem: true,
      icon: iconOk,
      description: [
        <>
          <span>
            PREBIÓTICOS*, <br />
          </span>
          son los nutrientes que encontrarás
          <b>
            {' '}
            en la nueva línea Pro-Defense V y que te traen muchos beneficios…
            ¿Por qué?
          </b>
        </>,
      ],
    },
    {
      icon: icon1,
      description: [
        <>
          <b>Conserva las defensas naturales </b>
          de tu Zona V.
        </>,
      ],
    },
    {
      icon: icon2,
      description: [
        <>
          <b> Mantiene tu pH saludable y en equilibrio </b>(beneficio asociado
          al ácido láctico)
        </>,
      ],
    },
    {
      icon: icon3,
      description: [
        <>
          {' '}
          Y porque finalmente <b>son el alimento de las bacterias sanas </b>
          que habitan en tu cuerpo.
        </>,
      ],
    },
  ]

  const [isOpen, setIsOpen] = useState(false)

  const cardsInfoComponent = () => {
    return cardsInfo.map((info, key) => (
      <div
        className="f-prebioticosSection-container__cardsInfo__container"
        key={key}
      >
        <figure className="f-prebioticosSection-container__cardsInfo__header">
          <img
            src={iconChat}
            alt="decoracion del chat"
            className="f-prebioticosSection-container__cardsInfo__header__imgChat"
          />
          <span className="f-prebioticosSection-container__cardsInfo__header__name">
            <b>{info.name}</b>
            <p>{info.ubication}</p>
          </span>
        </figure>
        <p className="f-prebioticosSection-container__cardsInfo__footerText">
          {info.comment}
        </p>
      </div>
    ))
  }

  const settings2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: 'slick-dots slick-thumb',
  }

  return (
    <div className="f-prebioticosSection-container">
      <section className="f-prebioticosSection-container__content">
        <div className="f-content-ref" ref={ref}>
          <CardChat
            iconUser={iconUser_1}
            className={`f-chatUser1 ${inView ? 'animacion' : ''}`}
          >
            <>
              <b>
                ¡Un segundo!
                <br /> ¿Qué son los prebióticos?, <br />
              </b>
              ¿esos no son los de los yogures?
            </>
          </CardChat>
        </div>
        <div className="f-content-ref" ref={ref2}>
          <CardChat
            chatNosotras
            iconUser={iconNosotras}
            className={`f-chatNosotras1 ${inView2 ? 'animacion' : ''}`}
          >
            <>
              <b>
                ¡Tranquila!
                <br />
              </b>
              Mira lo que opinan algunas mujeres sobre este
              {!isMobile && <br />}
              término, ¡tal vez esto es lo que piensas tú también!
            </>
          </CardChat>
        </div>
        <section className="f-prebioticosSection-container__cardsInfo">
          {isMobile ? (
            <Slider
              {...settings2}
              className="f-prebioticosSection-container__slider"
            >
              {cardsInfoComponent()}
            </Slider>
          ) : (
            cardsInfoComponent()
          )}
        </section>
        <div className="f-content-ref" ref={ref3}>
          <CardChat
            iconUser={iconUser_2}
            className={`f-chatUser2 ${inView3 ? 'animacion' : ''}`}
          >
            <>
              <b>Entonces, ¿qué son?</b>
            </>
          </CardChat>
        </div>
        <p className="f-prebioticosSection-container__textPrebioticos">
          ¡Aprendamos más sobre <b>los prebióticos, </b> <br />
          para que no te confundas con<b> los probióticos!</b>
        </p>
        <section className="f-prebioticosSection-container__prevspro">
          <div className="f-prebioticosSection-container__prevspro__prebioticos">
            {infoPrebioticos.map((element, key) => (
              <div
                className="f-prebioticosSection-container__prevspro__info"
                key={key}
              >
                <img src={element.icon} alt="icono de informacion" />
                <p
                  className={`f-prebioticosSection-container__prevspro__info__text ${
                    element.firstItem && 'firstItem'
                  }`}
                >
                  {element.description}
                </p>
              </div>
            ))}
          </div>
          <div
            className={`f-prebioticosSection-container__prevspro__probioticos ${
              isOpen && 'activeProbioticos'
            }`}
          >
            {isMobile && (
              <button
                className="f-prebioticosSection-container__prevspro__probioticos__buttonMore"
                onClick={() => setIsOpen(!isOpen)}
              >
                {isOpen ? '-' : '+'}
              </button>
            )}
            {infoProbioticos.map((element, key) => (
              <div
                className="f-prebioticosSection-container__prevspro__info"
                key={key}
              >
                <img src={element.icon} alt="icono de informacion" />
                <p
                  className={`f-prebioticosSection-container__prevspro__info__text secondColor ${
                    element.firstItem && 'firstItem'
                  }`}
                >
                  {element.description}
                </p>
              </div>
            ))}
          </div>
        </section>
        <div className="f-content-ref" ref={ref4}>
          <CardChat
            iconUser={iconUser_3}
            className={`f-chatUser1 ${inView4 ? 'animacion' : ''}`}
          >
            <>
              <b>
                Y ¿qué tienen que ver <br /> con mi Zona V?
              </b>
            </>
          </CardChat>
        </div>
        <div className="f-content-ref" ref={ref5}>
          <CardChat
            chatNosotras
            iconUser={iconNosotras}
            className={`f-chatNosotras1 f-chatNosotras2 ${
              inView5 ? 'animacion' : ''
            }`}
          >
            <>
              <b>
                ¡Sencillo!
                <br />
              </b>
              Con los <b>PREBIÓTICOS* </b>
              tu piel conserva las
              {!isMobile && <br />}
              defensas naturales para que estés protegida
              {!isMobile && <br />}
              ante los factores que la alteran.
            </>
          </CardChat>
        </div>
      </section>
    </div>
  )
}

export default PrebioticosSection
